/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { Button, Grid, Icon, Modal, Spacer } from "@cd2/components"
import { Fields } from "@cd2/forms"
import React, { useEffect, useState } from "react"
import { icons } from "../../constants/icons"
import { useFileboy } from "@cd2/fileboy-react"

export function ExportToSageButton({
  dataState,
  handleExport,
  loading,
  invalid,
  label = "Export to",
}: {
  dataState?: [data: string, setData: (data: string) => void]
  handleExport: () => void
  loading?: boolean
  invalid?: boolean
  label?: string
}) {
  const fileboy = useFileboy()
  const [initialState, setInitialState] = useState("")
  useEffect(() => {
    if (!loading) {
      setInitialState(dataState?.[0] ?? "")
    }
  }, [loading])
  const [isOpen, setIsOpen] = useState(false)

  const isDataValid = () => {
    if (!dataState) {
      return true
    }
    try {
      if (dataState[0] === "") {
        return true
      }
      JSON.parse(dataState?.[0] ?? "")
      return true
    } catch (e) {
      return false
    }
  }

  const isDiff = initialState !== dataState?.[0]

  const disabled = loading || invalid || !isDataValid()

  return (
    <React.Fragment>
      {dataState && (
        <Modal
          isOpen={isOpen}
          render={() => (
            <div>
              <Fields.TextArea
                label="Export JSON"
                value={dataState[0]}
                onChange={dataState[1]}
                rows={20}
              />
              <Spacer />
              <Grid columns={["auto", "max-content"]} gap={8}>
                <ExportToSageButton
                  handleExport={() => {
                    handleExport()
                    setIsOpen(false)
                  }}
                  invalid={disabled}
                />
                {isDiff && (
                  <Button
                    onClick={() => dataState[1](initialState)}
                    extendTheme={{ borderRadius: 6 }}
                  >
                    Reset state
                  </Button>
                )}
              </Grid>
            </div>
          )}
          onRequestClose={() => setIsOpen(false)}
        />
      )}
      <div
        css={css`
          border-radius: 6px;
          cursor: pointer;
          max-width: max-content;
          display: flex;
          align-items: center;
          font-weight: bold;
          overflow: hidden;
          border: 1px solid black;
          width: max-content;
          ${disabled &&
          css`
            opacity: 0.5;
          `}
        `}
      >
        <div
          onClick={disabled ? undefined : handleExport}
          css={css`
            color: white;
            padding: 12px;
            display: flex;
            gap: 8px;
            background: black;
          `}
        >
          {label}{" "}
          <img
            src={fileboy.buildImageUrl("sage_logo")}
            css={css`
              width: 32px;
              display: block;
            `}
          />
        </div>
        {loading && (
          <div
            onClick={() => setIsOpen(true)}
            css={css`
              background: #f5f5f5;
              margin: 0 8px;
            `}
          >
            <Icon icon={icons.spinner} spin />
          </div>
        )}
        {dataState && !loading && (
          <div
            onClick={() => setIsOpen(true)}
            css={css`
              background: #f5f5f5;
              margin: 0 8px;
            `}
          >
            <Icon icon={icons.file} />
          </div>
        )}
      </div>
    </React.Fragment>
  )
}
